var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("规则设置")]),
          _c(
            "div",
            [
              _c("h3", { staticStyle: { display: "inline-block" } }, [
                _vm._v("自动打标签"),
              ]),
              _c("a-switch", {
                staticStyle: { margin: "-8px 10px 0" },
                attrs: {
                  "checked-children": "是",
                  "un-checked-children": "否",
                },
                model: {
                  value: _vm.isAutoTag,
                  callback: function ($$v) {
                    _vm.isAutoTag = $$v
                  },
                  expression: "isAutoTag",
                },
              }),
              _vm._v(" 开启此功能后，当满足标签规则时自动为该用户打上标签 "),
            ],
            1
          ),
          _vm._l(_vm.tagRuleList, function (item, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAutoTag,
                    expression: "isAutoTag",
                  },
                ],
                key: item.tagRuleId,
              },
              [
                _c(
                  "div",
                  { staticClass: "rule-item" },
                  [
                    _c("h3", [_vm._v("规则" + _vm._s(index + 1) + ":")]),
                    _c("a-select", {
                      staticStyle: { width: "200px" },
                      attrs: { options: _vm.ruleTypeOptions },
                      model: {
                        value: item.ruleId,
                        callback: function ($$v) {
                          _vm.$set(item, "ruleId", $$v)
                        },
                        expression: "item.ruleId",
                      },
                    }),
                    item.ruleId === 1 ? [_c("span")] : _vm._e(),
                    item.ruleId === 2
                      ? [
                          _c("span", [_vm._v("达到")]),
                          _c("a-input", {
                            staticStyle: { width: "80px" },
                            model: {
                              value: item.ruleCondition,
                              callback: function ($$v) {
                                _vm.$set(item, "ruleCondition", $$v)
                              },
                              expression: "item.ruleCondition",
                            },
                          }),
                          _c("span", [_vm._v("人")]),
                        ]
                      : _vm._e(),
                    item.ruleId === 3
                      ? [
                          _c("span", [_vm._v("等级")]),
                          _c("a-select", {
                            staticStyle: { width: "200px" },
                            attrs: { options: _vm.labelOptions },
                            model: {
                              value: item.ruleCondition,
                              callback: function ($$v) {
                                _vm.$set(item, "ruleCondition", $$v)
                              },
                              expression: "item.ruleCondition",
                            },
                          }),
                          _c("span", [_vm._v("时")]),
                        ]
                      : _vm._e(),
                    _c("tagPicker", {
                      model: {
                        value: item.tagId,
                        callback: function ($$v) {
                          _vm.$set(item, "tagId", $$v)
                        },
                        expression: "item.tagId",
                      },
                    }),
                    _c("a-icon", {
                      attrs: { type: "plus-circle" },
                      on: {
                        click: function ($event) {
                          return _vm.add(index, item)
                        },
                      },
                    }),
                    _c("a-icon", {
                      attrs: { type: "minus-circle" },
                      on: {
                        click: function ($event) {
                          return _vm.delItem(index, item)
                        },
                      },
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.lastStep } }, [_vm._v("上一步")]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }